import React from 'react';
import config from 'react-global-configuration';

import {
  CoreLink,
  Block,
  Menu,
} from '@uncinc/react-drupal-core';

import { DOMAIN_VNL } from '../../../config/constants';
import Logo from '../../../components/Logo';

const FooterMenu = () => {
  const menuIdSuffix = config.get('CURRENT_DOMAIN') !== DOMAIN_VNL ? `-${config.get('CURRENT_DOMAIN')}` : '';

  return (
    <Menu id={`footer${menuIdSuffix}`}>
      {(items) => {
        return (
          <div className="row">
            {config.get('CURRENT_DOMAIN') !== DOMAIN_VNL && (
              <div className="Footer__items col-12 col-md-4 col-lg-3">
                <Logo footer url="https://www.veiligheid.nl" />
              </div>
            )}
            {items.map((item, index) => {
              const key = item.getIn(['link', 'meta_data', 'entity_id']);
              const title = item.getIn(['link', 'title'], 'Untitled');
              let classes = 'Footer__items col-12 col-md-4 col-lg-3';
              return (
                <div className={classes} key={key}>
                  <h2 className="Footer__items__title">{title}</h2>
                  <ul className="Footer__items__links">
                    {item.getIn(['subtree']).map((subItem, i) => {
                      const linkHref = subItem.getIn(['link', 'url']);
                      const linkTitle = subItem.getIn(['link', 'title'], '');
                      const classes = subItem.getIn(['link', 'options', 'attributes', 'class', 0]);

                      return (
                        <li key={linkTitle}>
                          <CoreLink
                            className={`Footer__items__link ${classes}`}
                            to={linkHref}
                          >
                            {linkTitle}
                          </CoreLink>
                        </li>
                      );
                    })}
                  </ul>
                </div>
              );
            })}
            {config.get('CURRENT_DOMAIN') === DOMAIN_VNL && (
              <div className="Footer__items col-12 col-md-4 col-lg-3 offset-lg-3">
                <h2 className="Footer__items__title">Contact</h2>
                <Block id="1" />
              </div>
            )}
          </div>
        );
      }}
    </Menu>
  );
};

export default FooterMenu;
